import Vue from 'vue'
import { axios } from './request'
import qs from 'qs'

const http = {
  //get
  get (url, options = {}) {
    return axios({
      url,
      method: 'GET',
      ...options
    })
  },
  post (url, data, options = {}) {
    return axios({
      url,
      data,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      ...options,
    })
  },
  postFile (url, data, options = {}) {
    return axios({
      url,
      data,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      ...options,
    })
  },
  put (url, data, options = {}) {
    return axios({
      url,
      data,
      method: 'PUT',
      ...options
    })
  },
  delete (url, data, options = {}) {
    return axios({
      url,
      data,
      method: 'DELETE',
      ...options
    })
  }
}

export {
  http
}


// WEBPACK FOOTER //
// ./src/utils/request/manage.js